/**
 * TanStack Query hooks for `reddit-ads-integration`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	redditAdsIntegrationQueryKeys,
	type CreateRedditAdsIntegrationBody,
	type ListRedditAdsIntegrationResponse,
	type RedditAdsIntegrationRow,
} from "./api";

export function useRedditAdsIntegrationList(): UseQueryResult<ListRedditAdsIntegrationResponse, Error> {
	return useQuery({
		queryKey: redditAdsIntegrationQueryKeys.list(),
		queryFn: list,
	});
}

export function useRedditAdsIntegrationCreate(): UseMutationResult<RedditAdsIntegrationRow, Error, CreateRedditAdsIntegrationBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: redditAdsIntegrationQueryKeys.all });
		},
	});
}

export function useRedditAdsIntegrationDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: redditAdsIntegrationQueryKeys.all });
		},
	});
}
